import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Layout, Icon } from 'antd';
import { Debounce } from 'react-throttle';
import WindowResizeListener from 'react-window-size-listener';
import { ThemeProvider } from 'styled-components';
import authAction from '../../redux/auth/actions';
import appActions from '../../redux/app/actions';
import telepaseActions from '../../redux/telepase/actions';
import Sidebar from '../Sidebar/Sidebar';
import Topbar from '../Topbar/Topbar';
import AppRouter from './AppRouter';
import { siteConfig } from '../../settings';
import themes from '../../settings/themes';
import { themeConfig } from '../../settings';
import AppHolder from './commonStyle';
import './global.css';
import Page500 from '../Page/500';
import NotificationTopbar from './NotificationTopbar';
const { Content, Footer } = Layout;
const { logout } = authAction;
const { toggleAll } = appActions;
export class App extends Component {
  state={
    hasError:false
  }
  componentDidMount(){
    if(this.props.user){
      this.props.fetchNotifications(this.props.user.codigoTitular);
    }
  }
  componentDidUpdate(prevProps){
    if(this.props.user && (!prevProps.user || prevProps.user.codigoTitular !== this.props.user.codigoTitular)){
      this.props.fetchNotifications(this.props.user.codigoTitular);
    }
  }
  componentDidCatch(error, info) {
    // Display fallback UI
    this.setState({ hasError: true });
    // You can also log the error to an error reporting service
    //logErrorToMyService(error, info);
  }
  saveRef = (obj, name) => {
    this[name] = obj;
  }
  handleClickNotification = (object) => {
    if(this.notificationTopbar && this.notificationTopbar.showInfo){
      this.notificationTopbar.showInfo(object)
    }
  }
  render() {
    const { url } = this.props.match;
    const { height, history } = this.props;
    const appHeight = window.innerHeight;
    /*if (this.state.hasError) {
      return(
        <Page500/>
      )
    }*/
    return (
      <ThemeProvider theme={themes[themeConfig.theme]}>
        <AppHolder>
          <Layout style={{ height: appHeight }}>
            <Debounce time="1000" handler="onResize">
              <WindowResizeListener
                onResize={windowSize =>
                  this.props.toggleAll(
                    windowSize.windowWidth,
                    windowSize.windowHeight
                  )
                }
              />
            </Debounce>
            <Topbar url={url} history={history} user={this.props.user} handleClickNotification={this.handleClickNotification}/>
            <Layout style={{ flexDirection: 'row', overflowX: 'hidden' }}>
              <Sidebar url={url} />
              {
                this.props.user?
                <Layout
                className="isoContentMainLayout"
                style={{
                  height: height,
                  position:'relative'
                }}
                >
                  <NotificationTopbar user={this.props.user} notifications={this.props.notifications} ref={(e) => this.saveRef(e, 'notificationTopbar')}/>
                  <Content
                  className="isomorphicContent"
                  style={{
                    padding: '70px 0 0',
                    flexShrink: '0',
                    background: 'rgb(61, 67, 84)',
                    position: 'relative'
                  }}
                  >
                  <AppRouter url={url} />
                  </Content>
                </Layout>
                :
                <Layout
                className="isoContentMainLayout"
                style={{
                  height: height,
                  position:'relative',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  backgroundColor: 'rgb(61, 67, 84)'
                }}
                >
                <Icon type="loading" style={{ fontSize: 40, color: '#3775f2' }} spin />
                </Layout>
              }
            </Layout>
          </Layout>
        </AppHolder>
      </ThemeProvider>
    );
  }
}

export default connect(
  state => ({
    auth: state.Auth,
    height: state.App.height,
    ...state.Telepase
  }),
  { logout, toggleAll, fetchNotifications: telepaseActions.fetchNotifications }
)(App);
